export const billing = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'surface',

  Sidebar: {},

  MainContent: {
    flow: 'y',
    flex: '1',
    padding: 'B C',
    gap: 'B',
    overflow: 'auto',
    '@tabletS': { padding: 'A B' },
    '@mobileL': { padding: 'A' },

    PageHeader: {
      flow: 'x',
      align: 'center space-between',
      '@mobileL': { flow: 'y', gap: 'A' },
      HeaderTitle: { tag: 'h1', text: '{{ billingTitle | polyglot }}', fontSize: 'C', fontWeight: '800', color: 'text', '@mobileL': { fontSize: 'B' } },
      HeaderRight: {
        flow: 'x', gap: 'A', align: 'center',
        '@mobileL': { flexWrap: 'wrap' },
        NewInvoiceBtn: { extends: 'Button', text: '+ {{ billingNewInvoice | polyglot }}', theme: 'primary', padding: 'Z A', fontSize: 'A', borderRadius: 'Z', cursor: 'pointer' },
        ThemeToggle: {},
      },
    },

    StatsRow: {
      flow: 'x',
      gap: 'A',
      flexWrap: 'wrap',
      Stat1: { extends: 'StatCard', StatValue: { text: '₾3,640' }, StatLabel: { text: '{{ billingTotalSent | polyglot }}' } },
      Stat2: { extends: 'StatCard', StatValue: { text: '₾640', color: 'green' }, StatLabel: { text: '{{ billingPaid | polyglot }}' } },
      Stat3: { extends: 'StatCard', StatValue: { text: '₾1,200', color: 'amber' }, StatLabel: { text: '{{ billingUnpaid | polyglot }}' } },
      Stat4: { extends: 'StatCard', StatValue: { text: '₾1,800', color: 'red' }, StatLabel: { text: '{{ billingOverdue | polyglot }}' } },
    },

    // Integration banner
    RsBanner: {
      flow: 'x', gap: 'Z', align: 'center', padding: 'Z A', background: 'greenBg', border: '1px solid greenBorder', borderRadius: 'Z',
      cursor: 'pointer', transition: 'opacity 150ms', ':hover': { opacity: '.85' },
      onClick: (e, el, s) => s.root.update({ rsDemo: !s.root.rsDemo }),
      BannerDot: { width: 'Y', height: 'Y', borderRadius: '100%', background: 'green', flexShrink: '0' },
      BannerText: { text: '{{ billingRsBanner | polyglot }}', fontSize: 'Y', color: 'green', flex: '1', lineHeight: '1.4' },
      BannerStatus: { tag: 'span', text: '{{ billingActive | polyglot }}', padding: 'Y Z', background: 'greenBg', border: '1px solid greenBorder', borderRadius: 'Z', fontSize: 'Y', color: 'green', fontWeight: '600' },
      BannerAction: { text: '→', fontSize: 'Z', color: 'green', fontWeight: '600' },
    },

    // rs.ge demo
    RsDemoPanel: {
      flow: 'y', gap: 'A', padding: 'A', background: 'surfaceMid', border: '1px solid surfaceBorderStrong', borderRadius: 'Z',
      if: (el, s) => s.root.rsDemo,
      DemoHeader: {
        flow: 'x', align: 'center space-between',
        DemoTitle: { tag: 'h3', text: '💰 {{ billingRsTaxSystem | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'green' },
        CloseBtn: { text: '✕', color: 'textMuted', cursor: 'pointer', fontSize: 'A', onClick: (e, el, s) => s.root.update({ rsDemo: false }) },
      },
      DemoCards: {
        flow: 'x', gap: 'Z', flexWrap: 'wrap',
        childExtends: { cursor: 'pointer', transition: 'transform 150ms, border-color 150ms', ':hover': { borderColor: 'green', transform: 'translateY(-2px)' } },
        Card1: {
          flow: 'y', gap: 'Y', padding: 'Z A', background: 'greenBg', border: '1px solid greenBorder', borderRadius: 'Z', flex: '1', minWidth: 'D',
          CardTitle: { text: '{{ billingClientStatus | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'text' },
          CardItem1: { text: '{{ billingClientName | polyglot }}', fontSize: 'Y', color: 'textSoft' },
          CardItem2: { text: '✓ {{ billingNoDebt | polyglot }}', fontSize: 'Y', color: 'green' },
          CardItem3: { text: '{{ billingLastCheck | polyglot }}', fontSize: 'Y', color: 'textSoft' },
          CardLink: { text: '{{ billingViewFull | polyglot }}', fontSize: 'Y', color: 'green', fontWeight: '600', marginTop: 'Y' },
        },
        Card2: {
          flow: 'y', gap: 'Y', padding: 'Z A', background: 'greenBg', border: '1px solid greenBorder', borderRadius: 'Z', flex: '1', minWidth: 'D',
          CardTitle: { text: '{{ billingEInvoice | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'text' },
          CardItem1: { text: '📄 INV-2024-031 — {{ billingStatusSent | polyglot }}', fontSize: 'Y', color: 'green' },
          CardItem2: { text: '📄 INV-2024-030 — {{ billingStatusPaid | polyglot }}', fontSize: 'Y', color: 'textSoft' },
          CardLink: { text: '{{ billingViewInvoices | polyglot }}', fontSize: 'Y', color: 'green', fontWeight: '600', marginTop: 'Y' },
        },
        Card3: {
          flow: 'y', gap: 'Y', padding: 'Z A', background: 'greenBg', border: '1px solid greenBorder', borderRadius: 'Z', flex: '1', minWidth: 'D',
          CardTitle: { text: '{{ billingAutoCheck | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'text' },
          CardItem1: { text: '🔔 {{ billingWeeklyEnabled | polyglot }}', fontSize: 'Y', color: 'green' },
          CardItem2: { text: '📧 {{ billingEmailNotification | polyglot }}', fontSize: 'Y', color: 'textSoft' },
          CardLink: { text: '{{ billingSettings | polyglot }}', fontSize: 'Y', color: 'green', fontWeight: '600', marginTop: 'Y' },
        },
      },
    },

    InvoiceList: {
      flow: 'y',
      gap: 'Z',

      InvHeader: {
        flow: 'x',
        padding: 'Z A',
        gap: 'A',
        borderBottom: '1px solid surfaceBorderStrong',
        '@mobileL': { display: 'none' },
        ColNum: { flex: '1', text: '{{ billingInvoice | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'textMuted' },
        ColClient: { flex: '2', text: '{{ billingClient | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'textMuted' },
        ColCase: { flex: '1', text: '{{ billingCase | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'textMuted' },
        ColAmount: { flex: '1', text: '{{ billingAmount | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'textMuted' },
        ColDue: { flex: '1', text: '{{ billingDue | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'textMuted' },
        ColStatus: { flex: '1', text: '{{ billingStatus | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'textMuted' },
      },

      InvRow1: {
        flow: 'x',
        padding: 'A',
        gap: 'A',
        align: 'center',
        background: 'surfaceCard',
        border: '1px solid surfaceBorderStrong',
        borderRadius: 'Z',
        cursor: 'pointer',
        '@mobileL': { flow: 'y', gap: 'Y' },
        Col1: { flex: '1', text: 'INV-2024-031', fontSize: 'Z', fontWeight: '500', color: 'text' },
        Col2: { flex: '2', text: '{{ billingClient1 | polyglot }}', fontSize: 'Z', color: 'text' },
        Col3: { flex: '1', text: '#2024-047', fontSize: 'Z', color: 'textMuted' },
        Col4: { flex: '1', text: '₾1,200', fontSize: 'Z', fontWeight: '600', color: 'text' },
        Col5: { flex: '1', text: '{{ billingDue1 | polyglot }}', fontSize: 'Z', color: 'amber' },
        Col6: { flex: '1', InvChip: { extends: 'StatusPending', text: '{{ billingUnpaid | polyglot }}' } },
      },
      InvRow2: {
        flow: 'x',
        padding: 'A',
        gap: 'A',
        align: 'center',
        background: 'surfaceCard',
        border: '1px solid surfaceBorderStrong',
        borderRadius: 'Z',
        cursor: 'pointer',
        '@mobileL': { flow: 'y', gap: 'Y' },
        Col1: { flex: '1', text: 'INV-2024-030', fontSize: 'Z', fontWeight: '500', color: 'text' },
        Col2: { flex: '2', text: '{{ billingClient2 | polyglot }}', fontSize: 'Z', color: 'text' },
        Col3: { flex: '1', text: '#2024-046', fontSize: 'Z', color: 'textMuted' },
        Col4: { flex: '1', text: '₾640', fontSize: 'Z', fontWeight: '600', color: 'text' },
        Col5: { flex: '1', text: '{{ billingDue2 | polyglot }}', fontSize: 'Z', color: 'textMuted' },
        Col6: { flex: '1', InvChip: { extends: 'StatusConfirmed', text: '{{ billingPaid | polyglot }}' } },
      },
      InvRow3: {
        flow: 'x',
        padding: 'A',
        gap: 'A',
        align: 'center',
        background: 'surfaceCard',
        border: '1px solid redBorder',
        borderRadius: 'Z',
        cursor: 'pointer',
        '@mobileL': { flow: 'y', gap: 'Y' },
        Col1: { flex: '1', text: 'INV-2024-029', fontSize: 'Z', fontWeight: '500', color: 'text' },
        Col2: { flex: '2', text: '{{ billingClient3 | polyglot }}', fontSize: 'Z', color: 'text' },
        Col3: { flex: '1', text: '#2024-045', fontSize: 'Z', color: 'textMuted' },
        Col4: { flex: '1', text: '₾1,800', fontSize: 'Z', fontWeight: '600', color: 'red' },
        Col5: { flex: '1', text: '{{ billingDue3 | polyglot }}', fontSize: 'Z', color: 'red', fontWeight: '600' },
        Col6: { flex: '1', InvChip: { tag: 'span', text: '{{ billingOverdue | polyglot }}', padding: 'Y Z', borderRadius: 'Z', fontSize: 'Y', fontWeight: '600', background: 'redBg', color: 'red', border: '1px solid redBorder' } },
      },
    },
  },
}
